import React, {useContext, useState} from 'react';
import ReactDOM from 'react-dom';
import { useModal } from '/src/ModalContext';
import {SettingsContext} from "/src/SettingsContext";
import {showMultiLingualText} from "@/utils/LanguageUtils";
import TourPoint from "@/pages/TourPoint";
import {useOverlay} from "@/OverlayContext";

const Modal = () => {
    const { isModalOpen, closeModal, modalContent, navigateTo } = useModal();

    const { tourSettings } = useContext(SettingsContext);

    const { setOverlay, isOverlayOpen, setOverlayIsVisible } = useOverlay();

    const clickAction = () => {

        console.log("modal click action", navigateTo);
        if (navigateTo) {
            console.log("open overlay for point", navigateTo);
            setOverlay(<TourPoint tourPoint={navigateTo} onContentLoaded={() => {
                console.log('Content loaded callback triggered');
                setOverlayIsVisible(true);
            }} />);
        }
        closeModal();
    }

    const [isLoading, setIsLoading] = useState(true);


    // Load the point icon
    const [pointIcon, setPointIcon] = useState(null);

    React.useEffect(() => {
        setIsLoading(false);

        if (modalContent?.point?.data?.icon) {
            setPointIcon(modalContent.point.data.icon.preview_url);
        }
    }, [modalContent?.point])

    if (!isModalOpen) return null;

    return !isLoading && ReactDOM.createPortal(
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="modal-overlay absolute inset-0 bg-gray-800 opacity-75"></div>
            <div className="modal-content bg-white p-2 rounded shadow-lg z-50 w-[80%] max-w-lg">



                <div className="text-right">  {/* fixed-container  */}

                    <button onClick={closeModal}
                            type="button"
                            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="staticModal">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"></path>
                        </svg>
                    </button>



                </div>

                <div className="py-3 px-2 text-center">
                    <p>{modalContent.intro}</p>
                </div>
                <div>

                    { modalContent.point && (
                    <div className="flex items-center justify-between w-full" style={{"minHeight": "48px"}}>

                        <div className="text-gray-900 flex-grow">
                            {showMultiLingualText(modalContent.point?.data?.title, modalContent.point?.data?.name)}
                        </div>
                        <div className="flex-shrink-0 ml-4">{pointIcon && <img alt="" className="w-12" src={pointIcon} />}</div>
                    </div>
                    )}



                </div>

                <div className="text-center mb-4">

                    <button onClick={clickAction}
                          style={{"backgroundColor": `${ tourSettings.theme_color }`, "color": `${ tourSettings.contrast_color }` }}
                          className="py-1 px-6 rounded-lg"> {modalContent.buttonText}
                    </button>

                </div>



            </div>
        </div>,
        document.getElementById('modal-root')
    );


};

export default Modal;